import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseInfoComponent } from "./base-info.component";
import { DatasourceService } from '@app/core/services';
import { Router } from '@angular/router';
import * as moment from 'moment'


@Component({
  selector: 'vehicle-info',
  styleUrls: ['./styles/styles-info.css'],
  styles: [`
    .card {
      height: auto;
    }
    .card-details {
      width: 75%;
    }
    .card-status {
      text-align: center;
      padding-bottom: 12px;
    }
    .card-status > div {
      color: white; 
      background-size: contain; 
      padding: 4px; 
      text-align: center; 
    }
    .card-status > img {
      width: 48px;
    }
    .k-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      border-color: transparent;
    }
    .section-title {
      padding-top: 8px;
      padding-bottom: 4px;
    }
  `],
  template: `
    <!--{{vehicle | json}}-->
    <div class="k-block" *ngIf="loading">
      <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
    </div>
    <div class="card" *ngIf="!loading">
      <div class="card-details">
        <div class="card-status">
          <img [src]="(vehicle.vehicle_type_image != '') ? vehicle.vehicle_type_image: defaultImage"/>
          <div style="background-color: #{{ vehicle.vehicle_status_color }}">
            {{ vehicle.vehicle_status_name }}
          </div>
        </div>
        <div class="card-subtitle">
          Fecha de entrada: <span class="right">{{ getDate(vehicle.entry_date) }}</span>
        </div>
        <div class="card-subtitle">
          Folio expediente / inventario: <span class="right">{{ vehicle.sku_exp }} / {{ vehicle.sku_inv }}</span>
        </div>

        <div class="section-title">
          <label class="k-label">Vehículo:</label>
        </div>
        <div class="card-subtitle">
          Marca: <span class="right">{{ vehicle.marck }}</span>
        </div>
        <div class="card-subtitle">
          Color: <span class="right">{{ vehicle.color }}</span>
        </div>
        <div class="card-subtitle">
          Placas: <span class="right">{{ vehicle.plaque }}</span>
        </div>
        <div class="card-subtitle no-wrap">
          Serie: <span class="right">{{ vehicle.serie }}</span>
        </div>
        <div class="card-subtitle no-wrap">
          Tipo de vehículo: <span class="right">{{ vehicle.vehicle_type_name }}</span>
        </div>

        <div class="section-title">
          <!--<label class="k-label">Vehículo:</label>-->
        </div>
        <div class="card-subtitle no-wrap">
          Lugar: <span class="right">{{ vehicle.place }}</span>
        </div>
        <div class="card-subtitle no-wrap">
           Depósito: <span class="right">{{ vehicle.deposit_name }}</span>
        </div>
        <div class="card-subtitle no-wrap">
           Autoridad: <span class="right">{{ vehicle.authority_abbreviation }} - {{ vehicle.authority_name }}</span>
        </div>
        
        <div class="section-title" *ngIf="vehicle.id_vehicle_status >= 2">
          <label class="k-label">Costos:</label>
        </div>        
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status >= 2">
          Costo de grúa: <span class="right">{{ intl.formatNumber(vehicle.cost_crane, "c2") }}</span>
        </div>  
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status >= 2">
          Costo pensión: ({{ vehicle.days }} días x {{ intl.formatNumber(vehicle.vehicle_type_fee, "c2") }}) <span class="right">{{ intl.formatNumber(vehicle.cost_pension, "c2") }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status >= 2">
          Subtotal: <span class="right">{{ intl.formatNumber(vehicle.cost_subtotal, "c2") }}</span>
        </div> 
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status >= 2">
          I.V.A.: (16%) <span class="right">{{ intl.formatNumber(vehicle.cost_iva, "c2") }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3">
          Costo total: <span class="right">{{ intl.formatNumber(vehicle.cost_total, "c2") }}</span>
        </div> 
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3">
          Descuento: ({{ intl.formatNumber(vehicle.cost_discount_perc, "p2") }}) <span class="right">{{ intl.formatNumber(vehicle.cost_discount, "c2") }}</span>
        </div>
        <div class="card-title no-wrap" *ngIf="vehicle.id_vehicle_status >= 2">
          <span class="right" style="font-size: 24px;">{{ intl.formatNumber(vehicle.cost_paid, "c2") }}</span>
        </div>

        <div class="section-title" *ngIf="vehicle.id_vehicle_status == 3 || vehicle.id_vehicle_status == 4">
          <label class="k-label">Liberación:</label>
        </div> 
        <div class="card-subtitle" *ngIf="vehicle.id_vehicle_status == 3 || vehicle.id_vehicle_status == 4">
          Fecha de salida: <span class="right">{{ getDate(vehicle.output_date) }}</span>
        </div>
        <div class="card-subtitle" *ngIf="vehicle.id_vehicle_status == 3 || vehicle.id_vehicle_status == 4">
          Duración: <span class="right">{{ vehicle.days }} días</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3">
          Forma de pago: <span class="right">{{ vehicle.payment_type_name }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3 || vehicle.id_vehicle_status == 4">
          Autoriza: <span class="right">{{ vehicle.person_name }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3 || vehicle.id_vehicle_status == 4">
          Núm. de factura: <span class="right">{{ vehicle.invoice }}</span>
        </div>
        
        <div class="section-title">
          <label class="k-label">Observaciones:</label>
        </div> 
        <div class="card-subtitle no-wrap">
          <span class="left">{{ vehicle.observations }}</span>
        </div>
      </div>            
    </div>
  `,    
})
export class VehicleInfoComponent extends BaseInfoComponent {

  //Input: id
  protected _id : number = 0;  

  @Input()
  set id(value: number) {

    this._id = value;
    // this.debug('set table = ' + this._table);
    this.loading = true;

    this.service.getById(this.table, this._id)
      .subscribe(
        (res: any) => {
          // console.log("RESPONSE------: ", res);
          this.vehicle = res;    

          //MODIFICAR SI EL ESTATUS ES IGUAL 2 => "POR LIBERAR"
          if(this.vehicle.id_vehicle_status == 2){
            var a = moment();
            var b = moment(this.vehicle.entry_date);
            let days: number = a.diff(b, 'days') + 1;
  
            this.vehicle.days = days;
            this.vehicle.cost_pension = days * parseFloat(this.vehicle.vehicle_type_fee);
            this.vehicle.cost_subtotal = this.vehicle.cost_crane + this.vehicle.cost_pension;
            this.vehicle.cost_iva = this.vehicle.cost_subtotal * 0.16;
            this.vehicle.cost_total = this.vehicle.cost_crane + this.vehicle.cost_pension + this.vehicle.cost_iva;
            this.vehicle.cost_paid = this.vehicle.cost_total;
          }
          
          this.loading = false;                                
          this.complete.emit({dataItem: res});
        },
        (fail: any) => {        
          console.log("Error", fail);
        }
      );

  }

  get id(): number { return this._id; }

  @Input() defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  public table: string = 'vehicles_inventories';

  public vehicle: any = {};

  public loading: boolean = false;

  @Output() complete = new EventEmitter<{dataItem: any}>();


  constructor(public intl: IntlService, public router: Router, protected service: DatasourceService) { 

    super(intl, router)

  }  

}